import React from "react";

function DustExtractorMachine() {
  return (
    <>
      <style>{`
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }
      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        margin-bottom: 20px;
      }
      .table {
        width: 100%;
        border-collapse: collapse;
        background: white;
      }
      .table-bordered {
        border: 1px solid #ddd;
      }
      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        font-size: 14px;
      }
      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      .table td:first-child {
        font-weight: 600;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>

        {/* Breadcrumb Section */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">Dust Extractor Machine</h1>
                  <div className="tj-page-link">
                    <span><i className="fa-solid fa-home" /></span>
                    <span><a href="/">Home</a></span>
                    <span><i className="fa-solid fa-arrow-right" /></span>
                    <span><span>Dust Extractor Machine</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div 
            className="page-header-overlay"
            data-bg-image="assets/images/shape/pheader-overlay.png"
          />
        </section>

        {/* MAIN CONTENT */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">

              {/* LEFT: CONTENT */}
              <div className="col-lg-8">
                <div className="post-details-wrapper">

                  {/* MAIN IMAGE */}
                  <div
                    className="blog-images wow fadeInUp"
                    data-wow-delay=".1s"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div className="col-sm-6">
                      <img
                        src="assets/images/SD_PHRMA_ALL_MIX _JPGS/35.png"
                        alt="Dust Extractor Machine"
                      />
                    </div>
                  </div>

                  <h2 className="title title-anim">Dust Extractor Machine</h2>

                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      The Dust Extractor Machine efficiently removes excess dust 
                      generated during tablet compression, granulation, and other 
                      powder processing operations. It ensures a clean production 
                      environment and protects both equipment and operators.
                    </p>

                    <p className="wow fadeInUp" data-wow-delay=".4s">
                      Featuring a stainless-steel body, high suction capacity, 
                      washable filter system, and noiseless operation, the dust 
                      extractor is an essential part of pharmaceutical processing lines.
                    </p>
                  </div>

                  {/* EXTRA IMAGES */}
                  <div className="images-wrap">
                    <div className="row">
                      <div className="col-sm-6">
                        <div 
                          className="image-box wow fadeInUp"
                          data-wow-delay=".3s"
                        >
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/35.png"
                            alt="Dust Extractor Side View"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div 
                          className="image-box wow fadeInUp"
                          data-wow-delay=".5s"
                        >
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/36.png"
                            alt="Dust Extractor Closeup"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* TECHNICAL SPECIFICATIONS */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>

                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-DE-1</td>
                          <td>DPM-DE-2</td>
                          <td>DPM-DE-3</td>
                        </tr>

                        <tr>
                          <td>Suction Capacity (CFM)</td>
                          <td>150 CFM</td>
                          <td>300 CFM</td>
                          <td>450 CFM</td>
                        </tr>

                        <tr>
                          <td>Motor Power</td>
                          <td>0.5 HP</td>
                          <td>1 HP</td>
                          <td>1.5 HP</td>
                        </tr>

                        <tr>
                          <td>Dust Storage Capacity</td>
                          <td>10 L</td>
                          <td>20 L</td>
                          <td>35 L</td>
                        </tr>

                        <tr>
                          <td>Filter Size</td>
                          <td>2 Microns</td>
                          <td>2 Microns</td>
                          <td>2 Microns</td>
                        </tr>

                        <tr>
                          <td>Material of Construction</td>
                          <td colSpan="3">SS 304 / SS 316 Contact Parts</td>
                        </tr>

                        <tr>
                          <td>Machine Dimensions (L × W × H)</td>
                          <td>550 × 400 × 900 mm</td>
                          <td>650 × 450 × 1000 mm</td>
                          <td>800 × 550 × 1150 mm</td>
                        </tr>

                        <tr>
                          <td>Machine Weight</td>
                          <td>55 kg</td>
                          <td>75 kg</td>
                          <td>95 kg</td>
                        </tr>

                      </tbody>
                    </table>

                  </div>

                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">

                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>
                    <ul>

                      <li>
                        <a href="/vibro-sifter">
                          Vibro Sifter Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right" /></span>
                        </a>
                      </li>

                      <li>
                        <a href="/multi-mill">
                          Multi Mill Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right" /></span>
                        </a>
                      </li>

                      <li>
                        <a href="/oscillating-granulator">
                          Oscillating Granulator
                          <span className="icon"><i className="fa-solid fa-arrow-right" /></span>
                        </a>
                      </li>

                    </ul>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
    </>
  );
}

export default DustExtractorMachine;
